<template>
  <div class="vehicle-model-selector">
    <oie-vehicle-selector v-if="mq('medium')" class="vehicle-island--parts-page" category="fordon"></oie-vehicle-selector>

    <section v-accordion="{ closeOthers: false, expandFirst: false, mediaQuery: true }" class="section-block vehicle-model-selector__vehicle-section">
      <div class="section-block__top">
        <h2 class="section-block__header">
          Välj tillverkare av traktor!
        </h2>
      </div>

      <div
        id="vehicles-model-selector-list-content"
        aria-labelledby="vehicles-model-selector-list-toggler"
        aria-hidden="true"
        class="grid grid--four vehicle-model-selector__vehicle-grid"
        data-show-rows="3">
        <a
          v-for="vehicle of realData.filter(item => {return item.code !== null})"
          :key="`vehicle-${vehicle.name}`"
          href="#0"
          class="navigational-item navigational-item--light-blue">
          {{ vehicle.name }}
        </a>

        <template v-if="realData.find(item => item.code === null)">
          <button v-vehicle-models-other-brands class="navigational-item navigational-item--light-blue navigational-item__other-brands">
            {{ realData.find(item => item.code === null).name }}
          </button>

          <a
            v-for="vehicle of realData.find(item => item.code === null).otherBrands"
            :key="`vehicle-${vehicle.name}`"
            href="#0"
            class="navigational-item navigational-item--is-hidden navigational-item--light-blue">
            {{ vehicle.name }}
          </a>
        </template>
      </div>

      <div class="section-block__bottom">
        <button
          id="vehicles-model-selector-list-toggler"
          class="interaction-item interaction-item--link-button accordion-vehicle-list__toggle js-accordion-toggler"
          aria-controls="vehicles-model-selector-list-content"
          aria-expanded="false">
          <div class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-reveal">
            <oie-use-svg svg="expand-circle"></oie-use-svg>
            Alla fordonstyper
          </div>

          <div class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-dismiss">
            <oie-use-svg svg="desmiss-circle"></oie-use-svg>
            Stäng
          </div>
        </button>
      </div>
    </section>

    <section v-accordion="{ closeOthers: false, expandFirst: false, mediaQuery: true }" class="section-block">
      <div class="section-block__top">
        <h2 class="section-block__header">
          Välj modell av John Deere
        </h2>

        <div class="section-block__top-right">
          <div class="section-block__top-filter-text">
            Filtrera model
          </div>

          <input type="text" class="vehicle-model-selector__filter-search js-vehicle-selector-filter-models" placeholder="Sök efter modell">
        </div>
      </div>

      <div id="vehicle-models" class="grid grid--four vehicle-model-selector__models-grid">
        <a
          v-for="(vehicle, i) of vehicles"
          :key="`vehicle-${i}`"
          href="#0"
          class="navigational-item navigational-item--arrow navigational-item--light-blue">
          model-{{ i }}
        </a>
      </div>

      <div class="section-block__bottom">
        <button class="interaction-item interaction-item--link-button accordion-vehicle-list__toggle js-accordion-toggler" aria-controls="vehicle-models" aria-expanded="false">
          <div class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-reveal">
            <oie-use-svg svg="expand-circle"></oie-use-svg>
            Alla modeller
          </div>

          <div class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-dismiss">
            <oie-use-svg svg="desmiss-circle"></oie-use-svg>
            Stäng
          </div>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    vehicles: [],
    realData: [
      {
        'code': 'CVLVehicleBrand|TraktorCASEIH',
        'name': 'CASE-IH',
        'url': '/sv/fordon/traktor/case-ih/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorDAVIDBROWNCASE',
        'name': 'DAVID BROWN-CASE',
        'url': '/sv/fordon/traktor/david-brown-case/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorDEUTZ',
        'name': 'DEUTZ',
        'url': '/sv/fordon/traktor/deutz/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorFENDT',
        'name': 'FENDT',
        'url': '/sv/fordon/traktor/fendt/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorFIAT',
        'name': 'FIAT',
        'url': '/sv/fordon/traktor/fiat/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorFORD',
        'name': 'FORD',
        'url': '/sv/fordon/traktor/ford/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorJOHNDEERE',
        'name': 'JOHN DEERE',
        'url': '/sv/fordon/traktor/john-deere/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorMASSEYFERGUSON',
        'name': 'MASSEY FERGUSON',
        'url': '/sv/fordon/traktor/massey-ferguson/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorNEWHOLLAND',
        'name': 'NEW HOLLAND',
        'url': '/sv/fordon/traktor/new-holland/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorVALMET',
        'name': 'VALMET/VALTRA',
        'url': '/sv/fordon/traktor/valmetvaltra/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorZETOR',
        'name': 'ZETOR',
        'url': '/sv/fordon/traktor/zetor/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorURSUS',
        'name': 'URSUS',
        'url': '/sv/fordon/traktor/ursus/',
        'otherBrands': [

        ]
      },
      {
        'code': 'CVLVehicleBrand|TraktorVOLVOBM',
        'name': 'VOLVO BM',
        'url': '/sv/fordon/traktor/volvo-bm/',
        'otherBrands': [

        ]
      },
      {
        'code': null,
        'name': 'Övriga märken',
        'url': '/sv/fordon/traktor/',
        'otherBrands': [
          {
            'code': 'CVLVehicleBrand|TraktorLAMBORGHINI',
            'name': 'LAMBORGHINI',
            'url': '/sv/fordon/traktor/lamborghini/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorSAME',
            'name': 'SAME',
            'url': '/sv/fordon/traktor/same/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorMcCORMICK',
            'name': 'McCORMICK',
            'url': '/sv/fordon/traktor/mccormick/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorNUFFIELD',
            'name': 'NUFFIELD',
            'url': '/sv/fordon/traktor/nuffield/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorFOTONKina',
            'name': 'FOTON (Kina)',
            'url': '/sv/fordon/traktor/foton-kina/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorKUBOTA',
            'name': 'KUBOTA',
            'url': '/sv/fordon/traktor/kubota/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorBELARUS',
            'name': 'BELARUS',
            'url': '/sv/fordon/traktor/belarus/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorMBTRAC',
            'name': 'MB TRAC',
            'url': '/sv/fordon/traktor/mb-trac/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorFARMALL',
            'name': 'FARMALL',
            'url': '/sv/fordon/traktor/farmall/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorMARSHALL',
            'name': 'MARSHALL',
            'url': '/sv/fordon/traktor/marshall/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorUNIVERSAL',
            'name': 'UNIVERSAL',
            'url': '/sv/fordon/traktor/universal/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorALLISCHALMERS',
            'name': 'ALLIS-CHALMERS',
            'url': '/sv/fordon/traktor/allis-chalmers/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorMASSEYHARRIS',
            'name': 'MASSEY HARRIS',
            'url': '/sv/fordon/traktor/massey-harris/',
            'otherBrands': [

            ]
          },
          {
            'code': 'CVLVehicleBrand|TraktorLEYLAND',
            'name': 'LEYLAND',
            'url': '/sv/fordon/traktor/leyland/',
            'otherBrands': [

            ]
          }
        ]
      }
    ]
  }),
  mounted() {
    for (let i = 0; i < 21; i++) {
      this.vehicles.push(i)
    }
  }
}
</script>
